import { Button } from "@/components/ui/button";
import { ArrowRight, PhoneCall } from "@phosphor-icons/react";
import { SCALED_LOGO, JONATHAN_SIGNUP_CARD_PHOTO } from "./constants";

export default function CtaAndSister({ onSignup }) {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12 gap-8">
        {/* LEFT — Main signup card (CVC primary) */}
        <div className="lg:col-span-7">
          <div
            data-testid="signup-here-card"
            className="rounded-3xl bg-cvc-navy text-cvc-cream p-10 md:p-14 relative overflow-hidden h-full"
          >
            <div className="absolute -top-12 -right-12 w-72 h-72 rounded-full bg-cvc-red/20 blur-3xl" />
            {/* Jonathan candid photo — bottom-right, doesn't enlarge the card */}
            <img
              src={JONATHAN_SIGNUP_CARD_PHOTO}
              alt="Jonathan Johnson — local Cache Valley Consulting expert."
              loading="lazy"
              data-testid="signup-here-jonathan"
              className="hidden md:block absolute bottom-10 right-10 lg:bottom-12 lg:right-12 w-52 lg:w-64 h-52 lg:h-64 object-cover rounded-2xl border-2 border-cvc-cream/15 shadow-xl"
            />
            <div className="relative max-w-xl">
              <p className="text-xs tracking-[0.3em] uppercase font-body font-semibold text-cvc-cream/70">Sign Up Here</p>
              <h2 className="font-heading text-4xl md:text-5xl text-cvc-cream mt-3 leading-tight">
                Have Jonathan come meet with you — locally, regularly.
              </h2>
              <p className="font-body text-cvc-cream/85 text-lg mt-5 leading-relaxed max-w-xs">
                Submit a signup request. We'll review your case, confirm fit, and book your first on-site session.
              </p>
              <Button
                data-testid="signup-here-button"
                onClick={onSignup}
                className="mt-8 bg-cvc-red hover:bg-cvc-red-deep text-white rounded-full px-9 py-6 h-auto text-base font-body"
              >
                Check availability <ArrowRight size={18} weight="bold" className="ml-2" />
              </Button>
              <p className="mt-6 font-body text-xs text-cvc-cream/60 max-w-xs">
                CVC reviews each request and either accepts you as a prepared-client, or recommends preparation steps first.
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT — Scaled sister program card (forest green; ONLY place Scaled logo appears) */}
        <aside className="lg:col-span-5">
          <div
            data-testid="scaled-sister-card"
            className="rounded-3xl bg-[#D8D0B8] text-cvc-ink p-10 h-full relative overflow-hidden"
          >
            <div className="absolute -bottom-16 -left-10 w-72 h-72 rounded-full bg-white/5 blur-3xl" />
            <div className="relative h-full flex flex-col">
              <p className="text-xs tracking-[0.3em] uppercase font-body font-semibold text-cvc-ink-soft">
                Nationwide sister program
              </p>
              <img src={SCALED_LOGO} alt="Scaled — ScaledEasy.com" data-testid="scaled-logo" className="mt-5 w-40 h-auto" />
              <p className="font-body text-base text-cvc-ink mt-6 leading-relaxed flex-1">
                Not in Cache Valley? Cache Valley Consulting's national counterpart, <span className="font-semibold">ScaledEasy.com</span>,
                delivers the same core scale-up program — phone-based, structured, and led by trained specialists.
              </p>
              <p className="font-body text-sm text-cvc-ink-soft mt-4 leading-relaxed">
                <strong className="text-cvc-ink">CVC's edge:</strong> Jonathan's local, in-person presence in Logan.
                <br />
                <strong className="text-cvc-ink">Scaled's edge:</strong> Jonathan's exact playbook, delivered nationally over the phone by dedicated specialists, moving you systematically through a 100-step DIY scale-up.
              </p>
              <a href="https://www.scaledeasy.com/" target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex items-center gap-2 font-body text-sm tracking-wider underline underline-offset-4 text-cvc-ink hover:text-white">
                <PhoneCall size={16} weight="duotone" /> Visit ScaledEasy.com
              </a>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}
